<template>
  <div class="app-shell d-flex flex-column align-items-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setBrandConfig } from "@/functions/setBrandConfig";

export default {
  computed: {
    ...mapState(["brandConfig"]),
  },
  beforeMount() {
    setBrandConfig();
    this.setTabName();
    this.setFavicon();
  },
  methods: {
    setTabName() {
      document.title = this.brandConfig?.tabTitle || "Battle League Gaming";
    },
    setFavicon() {
      if (!this.brandConfig?.brand) {
        return;
      }

      this.$nextTick(() => {
        const faviconPath = require(`@/brand/${this.brandConfig.brand}/assets/logo.png`);
        const link =
          document.querySelector("link[rel~='icon']") ||
          document.createElement("link");

        link.rel = "icon";
        link.type = "image/png";
        link.href = faviconPath;

        if (!link.parentNode) {
          document.head.appendChild(link);
        }
      });
    },
  },
};
</script>

<style>
body {
  margin: 0;
  background-color: #020202;
}

#app {
  min-height: 100vh;
}

.app-shell {
  min-height: 100vh;
  background-color: #020202;
}

.vue-container {
  min-height: 100vh;
}
</style>
